import styles from './CertificationItem.module.css';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Chip from '@mui/material/Chip';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import { removeCertification } from "../../api.js";
import { useAuth } from '../../AuthContext';

import { Badge } from '../Badge/Badge';

export const CertificationItem = ({ certification, onEdit, onDelete }) => {
    const { token } = useAuth();

    const prerequisites = Object.keys(certification.prerequisites || {});

    const handleDelete = async (e) => {
        e.stopPropagation();

        await removeCertification(certification.id, token);

        onDelete(certification.id);
    };

    return (
        <Accordion
            className={ styles.certification }
            defaultExpanded={ false }
            sx={ { width: '100%' } }
        >
            <AccordionSummary component="div" expandIcon={ <ExpandMoreIcon /> }>
                <div className={ styles.info }>
                    <Grid container alignItems="center" spacing={ 2 } sx={ { width: '100%' } }>
                        <Grid size={ { xs: 1 } }>
                            <Badge certification={ certification } certified={ true } />
                        </Grid>

                        <Grid size={ { xs: 4 } }>
                            <Typography className={ styles.gridItem }>{ certification.name }</Typography>
                        </Grid>

                        <Grid size={ { xs: 2 } }>
                            <Chip
                                label={ certification.type }
                                color={ certification.type === 'primary' ? 'primary' : 'secondary' }
                                size="small"
                            />
                        </Grid>

                        <Grid size={ { xs: 2 } }>
                            <Typography variant="body2" color="text.secondary">
                                { certification.refresh } days
                            </Typography>
                        </Grid>

                        <Grid size={ { xs: 2 } }>
                            <Typography variant="body2" color="text.secondary">
                                { prerequisites.length } prerequisites
                            </Typography>
                        </Grid>

                        <Grid size={ { xs: 1 } }>
                            <div className={ styles.actions }>
                                <IconButton size="small" onClick={ (e) => { e.stopPropagation(); onEdit(certification); } }>
                                    <EditIcon />
                                </IconButton>

                                <IconButton size="small" onClick={ handleDelete }>
                                    <DeleteIcon />
                                </IconButton>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </AccordionSummary>

            <AccordionDetails>
                <div className={ styles.details }>
                    <Typography variant="h6" gutterBottom>Details</Typography>

                    <Grid container spacing={ 2 }>
                        <Grid size={ { xs: 12, sm: 6 } }>
                            <Typography><strong>Name:</strong> { certification.name }</Typography>
                        </Grid>

                        <Grid size={ { xs: 12, sm: 6 } }>
                            <Typography><strong>Type:</strong> { certification.type }</Typography>
                        </Grid>

                        <Grid size={ { xs: 12, sm: 6 } }>
                            <Typography><strong>Refresh Period:</strong> { certification.refresh } days</Typography>
                        </Grid>

                        <Grid size={ { xs: 12, sm: 6 } }>
                            <Typography><strong>Badge:</strong> { certification.badge }</Typography>
                        </Grid>

                        { prerequisites.length > 0 && (
                            <Grid size={ { xs: 12 } }>
                                <Typography><strong>Prerequisites:</strong></Typography>

                                <div className={ styles.prerequisites }>
                                    { prerequisites.map(prereqId => (
                                        <Chip
                                            key={ prereqId }
                                            label={ `Cert ${ prereqId }` }
                                            size="small"
                                            variant="outlined"
                                        />
                                    )) }
                                </div>
                            </Grid>
                        ) }
                    </Grid>
                </div>
            </AccordionDetails>
        </Accordion>
    );
};